// This get replaced at build time via sed. See `bitbucket-pipelines.yml`.
const injectedEnv = 'staging';

const currentEnv = () => {
	return injectedEnv || 'local';
}

const isProd = () => {
    return injectedEnv === 'prod';
}

export { currentEnv, isProd };